import type { IProjectContext } from '../types'

export const getContext = (context: IProjectContext) => context
export const getPath = (context: IProjectContext) => context.path
